import React, { ImgHTMLAttributes } from 'react';
import currencyFlagMapping from './currencyFlagMapping.json';

interface CountryFlagProps
  extends Omit<ImgHTMLAttributes<HTMLImageElement>, 'src'> {
  countryCode: string;
}

export const CountryFlag: React.FC<CountryFlagProps> = ({
  countryCode,
  ...props
}) => {
  return (
    <img
      {...props}
      src={`/flags/${countryCode.toUpperCase()}.svg`}
      alt={countryCode}
    />
  );
};

interface CurrencyFlagProps
  extends Omit<ImgHTMLAttributes<HTMLImageElement>, 'src'> {
  currencyCode: string;
}

export const CurrencyFlag: React.FC<CurrencyFlagProps> = ({
  currencyCode,
  ...props
}) => {
  const countryCode: string | undefined = (currencyFlagMapping as any)[
    currencyCode
  ];
  if (!countryCode) {
    return null;
  }
  return (
    <CountryFlag
      {...props}
      countryCode={countryCode}
      className={`${props.className} shadow`}
    />
  );
};
